<template>
  <div id="app">
    <router-view />
    <footer-view />
  </div>
</template>

<script>
import FooterView from "./Footer";

export default {
  components: {
    FooterView
  }
};
</script>
